module.exports = __webpack_public_path__ + "static/img/home_qr_gzh.d13e4c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/homePage_new/home_qr_gzh.png
// module id = 0xBU
// module chunks = 62